import o from "./_root.js";
var r = o, a = r.Symbol, t = a;
export {
  t as default
};
//# sourceMappingURL=_Symbol.js.map
